import { z } from 'zod';

export const EmailCalendarTypeSchema = z.enum(['request', 'publish']);

export const EmailCalendarSchema = z.object({
  name: z.string().min(3),
  type: EmailCalendarTypeSchema,

  id: z.string().optional(),
  start: z.string(),
  end: z.string(),
  summary: z.string().optional(),
  description: z.string().optional(),
  location: z.string().optional(),
  url: z.string().url().optional(),
  timezone: z.string().optional(),
  allDay: z.boolean().optional(),
});

export type EmailCalendarType = z.infer<typeof EmailCalendarTypeSchema>;
export type EmailCalendar = z.output<typeof EmailCalendarSchema>;
export type EmailCalendarInput = z.input<typeof EmailCalendarSchema>;
